<template>
	<div :class="['row', theme]">
		<div
			v-for="(card, i) of cards"
			:key="i"
			:class="[
				'col',
				{
					'mt-200-smo': i !== 0
				}
			]"
		>
			<span :class="[titleSize, { 'text-color-greige': theme === 'dark' }]">
				{{ card.title }}
			</span>
			<p :class="[descriptionSize, { 'text-color-gray-40': theme === 'dark' }]">{{ card.description }}</p>
			<div v-if="card.link" class="mt-100">
				<BaseCtaLink classes="line-height-200" icon="arrow" :link="card.link" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { MarketingSiteCard } from 'types/marketing-site';
interface Props {
	cards: Array<MarketingSiteCard>;
	theme: 'light' | 'dark';
	titleSize?: string;
	descriptionSize?: string;
}
withDefaults(defineProps<Props>(), {
	titleSize: 'heading-4',
	descriptionSize: 'body-md'
});
</script>
<style lang="scss" scoped>
@use '../../styles/constants/colors' as *;
@use '../../styles/utilities/respond-to.scss' as *;

.row {
	display: flex;
	flex-wrap: wrap;
	row-gap: 1rem;
	column-gap: 4rem;

	.col {
		padding-top: 1rem;
		min-width: 250px; // to avoid columns from shrinking too narrow
	}

	&.light .col {
		border-top: 1px solid token('content-primary');
	}

	&.dark .col {
		border-top: 1px solid token('content-tertiary');
	}

	@include respond-to(smo) {
		.col {
			flex: 0 0 100%;
		}
	}

	@include respond-to(mdo) {
		column-gap: 4rem;
	}
}
</style>
